import React, {useState, useRef} from 'react';
import styles from './StemsDownload.module.scss'
import HeaderLogo from "components/headerLogo/HeaderLogo";
import {useHistory} from "react-router-dom";
import panelStyles from "components/homePanels/Panels.module.scss";
import ImageWrapper from "components/imageWrapper/ImageWrapper";
import MouseMove from "utils/MouseMove";
import LogoSprite from "components/logoSprite/LogoSprite";

const root = document.getElementsByTagName( 'html' )[0];
root.classList.add('static');
document.body.classList.add('static');

const StemsDownload = (props) => {

    const [agree, setAgreed] = useState(false);
    const history = useHistory();

    const backGround = useRef();
    const midGround = useRef();
    const bonusGround = useRef();

    const download = () => {
        window.open('https://msobd-storage.azureedge.net/videos/Hyperlandia_Instrumental_Stems.zip');
    }

    return (
        <>
            <div className={styles.page}>

                <HeaderLogo relative={true} menuClick={()=>history.push(`/`)}/>

                <div  className={styles.content}>
                    <div className={styles.spacer}/>

                    {/*<ImageWrapper className={`${panelStyles.logo} ${styles.logo}`} set={{*/}
                    {/*    default:`https://msobd-storage.azureedge.net/images/stems/silver_logo.png`}} alt={''} style={{marginBottom: 0}}/>*/}
                    <LogoSprite className={styles.logo} sprite={'https://msobd-storage.azureedge.net/images/stems/deadmau5_SplashAnimation_SpriteSheet_v5.png'} duration={3.5} steps={40} delay={0} size={385}/>

                    <h3>Become a Surface Original</h3>
                    <p>Want to win $25,000? Download the stems to “Hyperlandia” and post your own remix to Instagram or TikTok with <span>#OriginalByDesignContest</span>.</p>
                    <div className={styles.checkboxRow}>
                        <input aria-label={"I agree"} type={'checkbox'} onChange={()=>setAgreed(!agree)}/>
                        <div>I agree to the <a href={'/contest.pdf'} target={'_blank'} rel={"noreferrer"}>official rules</a></div>
                    </div>
                    <button className={`${panelStyles.button} ${panelStyles.white} ${styles.button}`} aria-disabled={!agree} disabled={!agree} onClick={download}><span>Download "Hyperlandia" stems&nbsp;(260mb)&nbsp;</span><span className={panelStyles.carat}>&rsaquo;&rsaquo;</span></button>
                    <a href={'/contest'} className={`${panelStyles.button} ${panelStyles.white} ${styles.button}`}><span>View contest entries</span><span className={panelStyles.carat}>&rsaquo;&rsaquo;</span></a>

                </div>

                <div className={styles.disclaimer}>
                    NO PURCHASE NECESSARY. INTERNET CONNECTION/INSTAGRAM™ OR TIKTOK™ NECESSARY. Starts 12:01 am PT on 6/1/21 & ends 11:59 pm PT on 7/31/21.  Open to legal residents of 50 US & DC 18 +. See <a href={'/contest.pdf'} target={'_blank'} rel="noreferrer">Official Rules</a> for complete details. Void where prohibited. Sponsor: Microsoft Corporation, One Microsoft Way, Redmond, WA 98052.
                </div>

            </div>

            <div className={styles.staticBg}>

                <div aria-hidden={true} ref={backGround} className={`${panelStyles.backGround} ${styles.backGround}`}>
                    <ImageWrapper className={styles.backGround} set={{
                        800:`https://msobd-storage.azureedge.net/images/stems/background_800.jpg`,
                        1350:`https://msobd-storage.azureedge.net/images/stems/background_1350.jpg`,
                        default:`https://msobd-storage.azureedge.net/images/stems/background.jpg`}} alt={''}/>
                </div>

                <div aria-hidden={true} ref={midGround} className={`${panelStyles.midGround} ${styles.midGround}`}>
                    <ImageWrapper className={styles.midGround} set={{
                        400:`https://msobd-storage.azureedge.net/images/stems/midGround_400.png`,
                        800:`https://msobd-storage.azureedge.net/images/stems/midGround_800.png`,
                        1350:`https://msobd-storage.azureedge.net/images/stems/midGround_1350.png`,
                        default:`https://msobd-storage.azureedge.net/images/stems/midGround.png`}} alt={''}/>
                </div>

                <div aria-hidden={true} ref={bonusGround} className={`${panelStyles.bonusGround} ${styles.bonusGround}`}>
                    <ImageWrapper className={styles.bonusGround} set={{
                        400:`https://msobd-storage.azureedge.net/images/stems/foreGround_400.png`,
                        800:`https://msobd-storage.azureedge.net/images/stems/foreGround_800.png`,
                        1350:`https://msobd-storage.azureedge.net/images/stems/foreGround_1350.png`,
                        default:`https://msobd-storage.azureedge.net/images/stems/foreGround.png`}} alt={''}/>
                </div>

                <div className={styles.darkBg}/>

                <MouseMove status={'active'} backGround={backGround} midGround={midGround} bonusGround={bonusGround} />

            </div>


        </>
    )
};

export default StemsDownload
